import { getAliCloudSmsRecord } from '../../api/notificationApi'
import NavBar from '../../components/nav-bar/nav-bar'
import translate from '../../i18n'
import styles from './index.module.less'
import { SearchOutlined } from '@ant-design/icons'
import { Button, Card, DatePicker, Form, Input, Space, Table, Tag } from 'antd'
import { ColumnsType } from 'antd/es/table'
import dayjs from 'dayjs'
import { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { compose } from 'redux'

export type IAliCloudSmsRecordFilterParams = {
  phoneNumber: string
  date: string
}

export type AliCloudSmsRecordResponse = {
  Code: string
  Message: string
  RequestId: string
  TotalCount: string
  SmsSendDetailDTOs: {
    SmsSendDetailDTO: SmsSendDetailDTO[]
  }
}

export type SmsSendDetailDTO = {
  ErrCode: string
  TemplateCode: string
  OutId: string
  ReceiveDate: string
  SendDate: string
  PhoneNum: string
  Content: string
  SendStatus: number
}

const AliCloudSmsRecordQuery = () => {
  const [form] = Form.useForm()
  const [aliCloudSmsRecord, setAliCloudSmsRecord] = useState<SmsSendDetailDTO[]>()

  const onFinish = (data: IAliCloudSmsRecordFilterParams) => {
    getAliCloudSmsRecord({
      ...data,
      date: dayjs(data.date).format('YYYYMMDD'),
    }).then((res: AliCloudSmsRecordResponse) => {
      setAliCloudSmsRecord(res.SmsSendDetailDTOs.SmsSendDetailDTO)
    })
  }

  const columns: ColumnsType<SmsSendDetailDTO> = [
    {
      title: 'PhoneNum',
      dataIndex: 'PhoneNum',
      key: 'PhoneNum',
    },
    {
      title: 'SendDate',
      dataIndex: 'SendDate',
      key: 'SendDate',
    },
    {
      title: 'ReceiveDate',
      dataIndex: 'ReceiveDate',
      key: 'ReceiveDate',
    },
    {
      title: 'TemplateCode',
      dataIndex: 'TemplateCode',
      key: 'TemplateCode',
    },
    {
      title: 'Content',
      dataIndex: 'Content',
      key: 'Content',
    },
    {
      title: 'SendStatus',
      dataIndex: 'SendStatus',
      key: 'SendStatus',
      render: sendStatus => {
        switch (sendStatus) {
          case 1:
            return (
              <Tag color="yellow">
                <FormattedMessage id="notification.status.pending" />
              </Tag>
            )
          case 2:
            return (
              <Tag color="red">
                <FormattedMessage id="notification.status.fail" />
              </Tag>
            )
          case 3:
            return (
              <Tag color="green">
                <FormattedMessage id="notification.status.success" />
              </Tag>
            )
        }
      },
    },
    {
      title: 'ErrCode',
      dataIndex: 'ErrCode',
      key: 'ErrCode',
      render: errorCode => {
        if (errorCode === 'DELIVERED') {
          return ''
        } else {
          return errorCode
        }
      },
    },
  ]

  return (
    <Space className={styles['dashboard-wrapper']} orientation="vertical">
      <NavBar title={translate('menuBar.aliCloudSmsRecord')} />
      <Card>
        <Space className={styles['dashboard-wrapper']} orientation="vertical">
          <div className={styles['filter-bar']}>
            <Form form={form} layout="inline" className="filter-inline-form" onFinish={onFinish}>
              <Form.Item name="phoneNumber" label="电话号" rules={[{ required: true }]}>
                <Input />
              </Form.Item>
              <Form.Item name="date" label="日期" rules={[{ required: true }]}>
                <DatePicker format="YYYY-MM-DD" />
              </Form.Item>
              <Form.Item>
                <Button type="primary" htmlType="submit" icon={<SearchOutlined />}>
                  <FormattedMessage id="search" />
                </Button>
              </Form.Item>
            </Form>
          </div>
          <Table rowKey={record => record.OutId} columns={columns} dataSource={aliCloudSmsRecord} />
        </Space>
      </Card>
    </Space>
  )
}

export default compose()(AliCloudSmsRecordQuery)
